import { render, staticRenderFns } from "./BlockchainPublicKey.vue?vue&type=template&id=43b2f6fe&"
import script from "./BlockchainPublicKey.vue?vue&type=script&lang=js&"
export * from "./BlockchainPublicKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports